import { SerializedStyles } from '@emotion/core'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import { BlogAuthor } from './blog'
import { TemplateCreatorProps } from './templates'

export const learnBreakPoint = 1000 // px

export interface LearnProps {
  data: {
    categories: {
      edges: {
        node: LearnCategory
      }[]
    }

    learnAuthors: {
      edges: {
        node: LearnAuthor
      }[]
    }

    allTopArticles: {
      edges: {
        node: LearnArticle
      }[]
    }
  }
}

export interface LearnAuthor {
  name: string
  slug: string
  companyName?: string
  jobTitle?: string

  authorPhoto: {
    gatsbyImageData: IGatsbyImageData
  }

  description?: {
    description?: string
  }

  socialLinks?: {
    title: string
    url: string
  }[]

  authorPublications?: LearnArticle[]
}

export interface LearnAuthorProps {
  data: {
    author: LearnAuthor
    allLearnAuthors: {
      edges: {
        node: LearnAuthor
      }[]
    }
  }
}

export interface AuthorAvatarProps {
  id?: string
  isInSidebar?: boolean
  withDescription?: boolean
  clampDescription?: boolean
  blackBG?: boolean
  author: LearnAuthor | BlogAuthor | TemplateCreatorProps
  leftOnSmall?: boolean
  cssStyles?: SerializedStyles
}

export interface LearnCategory {
  categoryLogo: {
    title: string
    gatsbyImageData: IGatsbyImageData
  }
  categoryWhiteLogo: {
    title: string
    gatsbyImageData: IGatsbyImageData
  }
  slug: string
  name: string
  description: {
    description: string
  }
  categoryColor: string
  categoryArticles: LearnArticle[]
  categoryAuthors: {
    author: LearnAuthor
  }[]
}

export interface LearnCategoryProps {
  data: {
    category: LearnCategory
    essentialArticles: {
      edges: {
        node: LearnArticle
      }[]
    }
    subcategories: {
      edges: {
        node: LearnSubcategory
      }[]
    }
    allCategories: {
      edges: {
        node: LearnCategory
      }[]
    }
  }
}

export interface LearnCategoriesMenuProps {
  isHero?: boolean
  headlineText: string
  subheaderText?: string
  categories?: {
    edges: {
      node: LearnCategory
    }[]
  }
  search?: string
  setSearch?: (value: string) => void
  cssStyles?: SerializedStyles
  withBackgroundMesh?: boolean
  withoutBorder?: boolean
  withCategoryTabs?: boolean
  logoSrc?: {
    title: string
    gatsbyImageData: IGatsbyImageData
  }
  skipCategory?: string
  withoutPadding?: boolean
}

export interface LearnSubcategory {
  slug: string
  name: string
  description: {
    description: string
  }
  category: LearnCategory
  subcategoryArticles: LearnArticle[]
}

export interface LearnSubcategoryProps {
  data: {
    subcategory: LearnSubcategory
    allCategories: {
      edges: {
        node: LearnCategory
      }[]
    }
    learnArticles: LearnArticle[]
  }
}

export interface LearnArticle {
  soon: boolean
  author: LearnAuthor
  title: string
  slug: string
  category: LearnCategory
  createdAt: string

  heroImage: {
    gatsbyImageData: IGatsbyImageData
    file: {
      url: string
    }
  }

  abstract: {
    abstract: string
  }

  funnelStage: 'TOFU' | 'MOFU' | 'BOFU'
  content: {
    raw: string
    references: ContentfulRichTextGatsbyReference[]
  }

  subcategories?: {
    name: string
    slug: string
  }[]
}

export interface LearnArticleCardProps {
  title: string
  description?: string
  categoryColor: string
  isSmall?: boolean
  isSoon: boolean
  articleUrl: string
  logoSrc?: {
    title: string
    gatsbyImageData: IGatsbyImageData
  }
  createdAt: string
  author: LearnAuthor
}

export interface LearnArticleProps {
  data: {
    article: LearnArticle
    topArticles: {
      edges: {
        node: LearnArticle
      }[]
    }
  }
}
